// @LTG-ID: F-093
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-093, source `Journals/what-is-my-business-worth.html`
//        lines 1118-1168 (Figure 03 — same-EBITDA different-multiple bar chart).
// @CHANGED: 2026-02 session_004 (CHG-0059)
// @OWNER: web
//
// F-083 — Brief-page infographic: "Same EBITDA. Different multiple." Verbatim
// port of source Figure 03. 720x320 viewBox; five rising bars (5x..9x)
// representing the same $5M EBITDA business under progressively better
// concentration / owner-dependency / recurring-revenue postures, with a
// dashed connector line through the top labels.

export const SameEbitdaDifferentMultiple = () => {
    return (
        <div
            className="ltg-brief-infographic"
            data-testid="brief01-figure-03"
        >
            <span className="ltg-brief-infographic-label">
                Figure 03 &middot; Same EBITDA. Different multiple.
            </span>
            <h4>
                How the three highest-impact levers compound on a $5M EBITDA
                business.
            </h4>
            <svg
                viewBox="0 0 720 320"
                className="ltg-brief-risk-chart"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <line x1="60" y1="40" x2="60" y2="270" stroke="#d8d3c6" strokeWidth="1" />
                <line x1="60" y1="270" x2="680" y2="270" stroke="#d8d3c6" strokeWidth="1" />

                <text x="60" y="28" fontFamily="Geist Mono, monospace" fontSize="10" fill="#6a7a92" letterSpacing="1.2">
                    ENTERPRISE VALUE
                </text>

                <line x1="55" y1="60" x2="65" y2="60" stroke="#d8d3c6" />
                <line x1="55" y1="120" x2="65" y2="120" stroke="#d8d3c6" />
                <line x1="55" y1="180" x2="65" y2="180" stroke="#d8d3c6" />
                <line x1="55" y1="240" x2="65" y2="240" stroke="#d8d3c6" />

                <text x="50" y="64" fontFamily="Geist Mono, monospace" fontSize="10" fill="#6a7a92" textAnchor="end" letterSpacing="0.6">$40M</text>
                <text x="50" y="124" fontFamily="Geist Mono, monospace" fontSize="10" fill="#6a7a92" textAnchor="end" letterSpacing="0.6">$30M</text>
                <text x="50" y="184" fontFamily="Geist Mono, monospace" fontSize="10" fill="#6a7a92" textAnchor="end" letterSpacing="0.6">$20M</text>
                <text x="50" y="244" fontFamily="Geist Mono, monospace" fontSize="10" fill="#6a7a92" textAnchor="end" letterSpacing="0.6">$10M</text>

                <rect x="100" y="195" width="80" height="75" fill="#0A2A5E" opacity="0.4" />
                <text x="140" y="290" fontFamily="Source Serif 4, serif" fontSize="12" fill="#0A2A5E" textAnchor="middle" fontStyle="italic">5x</text>
                <text x="140" y="305" fontFamily="Geist Mono, monospace" fontSize="9" fill="#6a7a92" textAnchor="middle" letterSpacing="0.8">CONCENTRATION RISK</text>
                <text x="140" y="190" fontFamily="Source Serif 4, serif" fontSize="16" fill="#0A2A5E" textAnchor="middle" fontWeight="600">$25M</text>

                <rect x="220" y="155" width="80" height="115" fill="#0A2A5E" opacity="0.6" />
                <text x="260" y="290" fontFamily="Source Serif 4, serif" fontSize="12" fill="#0A2A5E" textAnchor="middle" fontStyle="italic">6x</text>
                <text x="260" y="305" fontFamily="Geist Mono, monospace" fontSize="9" fill="#6a7a92" textAnchor="middle" letterSpacing="0.8">OWNER DEPENDENT</text>
                <text x="260" y="150" fontFamily="Source Serif 4, serif" fontSize="16" fill="#0A2A5E" textAnchor="middle" fontWeight="600">$30M</text>

                <rect x="340" y="120" width="80" height="150" fill="#18B0BD" opacity="0.85" />
                <text x="380" y="290" fontFamily="Source Serif 4, serif" fontSize="12" fill="#0A2A5E" textAnchor="middle" fontStyle="italic">7x</text>
                <text x="380" y="305" fontFamily="Geist Mono, monospace" fontSize="9" fill="#6a7a92" textAnchor="middle" letterSpacing="0.8">SECTOR MEDIAN</text>
                <text x="380" y="115" fontFamily="Source Serif 4, serif" fontSize="16" fill="#0A2A5E" textAnchor="middle" fontWeight="600">$35M</text>

                <rect x="460" y="85" width="80" height="185" fill="#B08D3E" opacity="0.7" />
                <text x="500" y="290" fontFamily="Source Serif 4, serif" fontSize="12" fill="#0A2A5E" textAnchor="middle" fontStyle="italic">8x</text>
                <text x="500" y="305" fontFamily="Geist Mono, monospace" fontSize="9" fill="#6a7a92" textAnchor="middle" letterSpacing="0.8">RECURRING REVENUE</text>
                <text x="500" y="80" fontFamily="Source Serif 4, serif" fontSize="16" fill="#0A2A5E" textAnchor="middle" fontWeight="600">$40M</text>

                <rect x="580" y="55" width="80" height="215" fill="#B08D3E" />
                <text x="620" y="290" fontFamily="Source Serif 4, serif" fontSize="12" fill="#0A2A5E" textAnchor="middle" fontStyle="italic">9x</text>
                <text x="620" y="305" fontFamily="Geist Mono, monospace" fontSize="9" fill="#6a7a92" textAnchor="middle" letterSpacing="0.8">ALL THREE RIGHT</text>
                <text x="620" y="50" fontFamily="Source Serif 4, serif" fontSize="16" fill="#0A2A5E" textAnchor="middle" fontWeight="600">$45M</text>

                <line x1="100" y1="195" x2="680" y2="55" stroke="#0A2A5E" strokeWidth="1" strokeDasharray="3,4" opacity="0.4" />
            </svg>
            <p className="ltg-brief-infographic-caption">
                Same $5M EBITDA business. Three levers, in increasing impact:
                customer concentration, owner dependency, recurring revenue
                mix. Moving from the worst posture on all three to the best is
                the difference between $25M and $45M of enterprise value at
                sale, on identical earnings.
                <cite>
                    Illustrative; multiple ranges synthesized from FOCUS July
                    2025, CT Acquisitions 2026, and Pepperdine PCM 2025
                </cite>
            </p>
        </div>
    );
};

export default SameEbitdaDifferentMultiple;
